import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  resetBlogs({ commit }) {
    commit(types.RESET_BLOGS)
  },
  resetComments({ commit }) {
    commit(types.RESET_COMMENTS)
  },
  resetAttachments({ commit }) {
    commit(types.RESET_ATTACHMENTS)
  },
  initBlog({ commit }, firm) {
    commit(types.INIT_BLOG, firm)
  },
  setBlog({ commit }, data) {
    commit(types.SET_BLOG, data)
  },
  updateBlog({ commit }, data) {
    commit(types.UPDATE_BLOG, data)
  },
  initComment({ commit }, blog) {
    commit(types.INIT_COMMENT, blog)
  },
  updateComment({ commit }, data) {
    commit(types.UPDATE_COMMENT, data)
  },
  setComment({ commit }, data) {
    commit(types.SET_COMMENT, data)
  },
  setStatus({ commit }, status) {
    commit(types.SET_STATUS, status)
  },
  setType({ commit }, type) {
    commit(types.SET_TYPE, type)
  },
  setSearchTerm({ commit }, searchTerm) {
    commit(types.SET_SEARCH_TERM, searchTerm)
  },
  setPageSize({ commit }, pageSize) {
    commit(types.SET_PAGE_SIZE, pageSize)
  },
  setOrderBy({ commit }, orderBy) {
    commit(types.SET_ORDER_BY, orderBy)
  },
  setSortBy({ commit }, sortBy) {
    commit(types.SET_SORT_BY, sortBy)
  },
  resetShow({ commit }, data) {
    commit(types.RESET_SHOW, data)
  },
  async getBlogs({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getBlogs', () =>
      http.get('blog/blogs', {
        params: options
      })
    )
    commit(types.SET_BLOGS, r.data)
    return r.data
  },
  async getBlog({ commit, dispatch }, blog) {
    const r = await startLoading(dispatch, 'getBlog', () => http.get(`blog/blog?blog=${blog}`))
    commit(types.SET_BLOG, r.data)
    return r.data
  },
  async searchBlogs({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'searchBlogs', () => http.get(`blog/blogSearch?firm=${data.firm}&searchTerm=${data.search}`))
    commit(types.SET_FOUND_BLOGS, r.data)
    return r.data
  },
  async saveBlog({ state, dispatch }) {
    const r = await startLoading(dispatch, 'saveBlog', () => http.post('blog/saveBlog', state.blog))
    return r.data
  },
  async deleteBlog({ commit, dispatch }, blog) {
    const r = await startLoading(dispatch, 'deleteBlog', () => http.post(`blog/deleteBlog?blog=${blog}`))
    return r.data
  },
  async getAttachments({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getBlog', () => http.get(`blog/attachments?blog=${data.blog}&blogComment=${data.blogComment}`))
    commit(types.SET_ATTACHMENTS, r.data)
    return r.data
  },
  async deleteAttachment({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAttachment', () => http.post(`blog/deleteAttachment?blogAttachment=${id}`))
    return r.data
  },
  async getComments({ commit, dispatch }, blog) {
    const r = await startLoading(dispatch, 'getComments', () => http.get(`blog/comments?blog=${blog}`))
    commit(types.SET_COMMENTS, r.data)
    return r.data
  },
  async saveComment({ state, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveComment', () => http.post('blog/saveComment', data))
    return r.data
  },
  async deleteComment({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteComment', () => http.post(`blog/deleteComment?blogComment=${id}`))
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/blog/actions.js